export default "__VITE_ASSET__1dc9d66f__"